//Install
import React, { Component } from "react";
//Install
import { ReactComponent as E03I1C } from "../../Media/Icon/008.svg";

//Element
class Nav extends Component {
    //Element
    onClick = (e) => {
        //Element
        e.preventDefault()
        //Element
        let Body = document.getElementsByTagName( "body" )[0]
        //Element
        let Icon = document.getElementById( "Web_AL8709" )
        //Element
        let Close = document.getElementById( "Web_HW24G3" )
        //Element
        let Menu = document.getElementsByClassName( "j11251" )[0]
        //Element
        Icon.classList.toggle( "d-none" )
        //Element
        Close.classList.toggle( "d-none" )
        //Element
        Menu.classList.toggle( "d-none" )
        //Element
        Body.classList.toggle( "overflow-hidden" )
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("button", { id: "Web_AL8709", name: "Web_AL8709", className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB g06th7", type: "button", onClick: this.onClick },
            //Element
            React.createElement(E03I1C, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Nav;